import { Box, List, ListItem, ListItemIcon, Stack, Typography } from '@mui/material'
import { WarningCircle as WarningCircleIcon } from '@phosphor-icons/react'

import { Dialog, PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

import { CloneNewButton } from './CloneNewButton'
import { ReturnButton } from './ReturnButton'
import { StartNewButton } from './StartNewButton'

interface FinalizeSuccessDialogContent {
  returnUrl?: string | null
}

export const FinalizeSuccessDialogContent = (props: FinalizeSuccessDialogContent) => {
  const { returnUrl } = props

  return (
    <Dialog.ContentLayout
      controlsPosition="end"
      body={
        <>
          <Stack direction="row" justifyContent="space-between">
            <Box sx={{ width: '60%' }}>
              <Typography variant="h4" gutterBottom id="success-dialog-title">
                You're Almost There
              </Typography>
              <Typography variant="body1" gutterBottom id="success-dialog-description" sx={{ marginTop: 2 }}>
                Your design has been saved and quote created, what do you wish to do next? You can start a new design
                from your current design, start from the main template page or proceed to your quote to order in
                Daveweb.
              </Typography>
            </Box>
            <List>
              <ListItem>
                <ListItemIcon>
                  <PhxIcon name="CheckCircle" style={{ fontSize: 30, color: 'green' }} />
                </ListItemIcon>
                <Typography variant="body1">Your Design has been made</Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <PhxIcon name="CheckCircle" style={{ fontSize: 30, color: 'green' }} />
                </ListItemIcon>
                <Typography variant="body1">Your Quote has been created</Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <WarningCircleIcon style={{ fontSize: 30 }} />
                </ListItemIcon>
                <Typography variant="body1">View your Quote in Daveweb</Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <WarningCircleIcon style={{ fontSize: 30 }} />
                </ListItemIcon>
                <Typography variant="body1">Check out in your cart</Typography>
              </ListItem>
            </List>
          </Stack>
        </>
      }
      controls={
        <>
          {returnUrl && <ReturnButton returnUrl={returnUrl} />}
          <CloneNewButton />
          <StartNewButton />
        </>
      }
    />
  )
}
